import { useContext } from "react";
import { PensionContext } from "../../../contexts/pension-robot/PensionContext";

export const useYearsUntilPensionAge = (isPartnerSection: boolean) => {
    const { parameters: { personalInfo } } = useContext(PensionContext);
    return isPartnerSection
        ? (personalInfo.partner?.pensionAge ?? 0) - (personalInfo.partner?.age ?? 0)
        : (personalInfo.self?.pensionAge ?? 0) - (personalInfo.self?.age ?? 0)
}